<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-8">
          <strong class="card-title mb-3">Market Information</strong>
        </div>
        <div class="col-md-3">
          <download :tableId="'market-info'" :fileName="'market-info'"></download>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-3">
          <div class="form-group">
            <datepicker
              :input-class="'form-control'"
              :format="'dd-MM-yyyy'"
              v-model="ddate"
              @selected="getSelDate($event)"
            ></datepicker>
          </div>
        </div>
        <div class="col-md-6"></div>
        <div class="col-md-3">
          <div class="form-group">
            <!-- <input
              class="form-control"
              v-model="searchText"
              placeholder="Search"
              @keyup="filteredList($event)"
            >-->
          </div>
        </div>
      </div>
      <!-- <hr> -->
      <div class="table-responsive app" v-dragscroll="true">
        <table id="market-info" class="table table-bordered fonts11 app-inner">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th>> 0</th>
              <th>> 500</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(field, index) in tableFields" v-bind:key="'td'+field.title+index">
              <td class="text-bold">{{field.name}}</td>
              <td>
                <span
                  v-if="rawData.common_data"
                >{{(field.isNumeric)? getFixed(rawData.common_data[field.title]): rawData[field.title]}}</span>
                <span v-else>-</span>
              </td>
              <td>
                <!-- <span v-if="field.title==='market_average_shares_outstanding'"> {{(field.isNumeric)? getFixed(rawDataGtZero['avg_shares_outstanding']): rawDataGtZero['avg_shares_outstanding']}}</span>
                <span v-else-if="field.title==='average_marketCapitalization'"> {{(field.isNumeric)? getFixed(rawDataGtZero['avg_marketCapitalization']): rawDataGtZero['avg_marketCapitalization']}}</span>
                <span v-else-if="field.title==='cut_off_book_market_ratio'"> {{(field.isNumeric)? getFixed(rawDataGtZero['cut_off_bmr_ratio']): rawDataGtZero['cut_off_bmr_ratio']}}</span>-->
                <span
                  v-if="rawData.common_data_GreaterThanZero"
                >{{(field.isNumeric)? getFixed(rawData.common_data_GreaterThanZero[field.title]): rawData.common_data_GreaterThanZero[field.title]}}</span>
                <span v-else>-</span>
              </td>
              <td>
                <!-- <span
                  v-if="field.title==='market_average_shares_outstanding'"
                >{{(field.isNumeric)? getFixed(rawDataGt500['avg_shares_outstanding']): rawDataGt500['avg_shares_outstanding']}}</span>-->
                <!-- <span v-else-if="field.title==='average_marketCapitalization'"> {{(field.isNumeric)? getFixed(rawDataGt500['avg_marketCapitalization']): rawDataGt500['avg_marketCapitalization']}}</span>
                <span v-else-if="field.title==='cut_off_book_market_ratio'"> {{(field.isNumeric)? getFixed(rawDataGt500['cut_off_bmr_ratio']): rawDataGt500['cut_off_bmr_ratio']}}</span>-->
                <span
                  v-if="rawData.common_data_GreaterThanFiveHundred"
                >{{(field.isNumeric)? getFixed(rawData.common_data_GreaterThanFiveHundred[field.title]): rawData.common_data_GreaterThanFiveHundred[field.title]}}</span>
                <span v-else>-</span>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- <div class="alert alert-danger" role="alert" v-else>No data found!</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import Datepicker from "vuejs-datepicker";
export default {
  props: ["company"],
  components: { Datepicker },
  mixins: [commonMixins],
  created() {
    this.getRawData();
    // this.getGt500();
    // this.getGtZero();
  },
  data() {
    return {
      tableFields: [
        {
          title: "market_average_sales_during_the_trailing_12_months",
          name: "Market average sales during the trailing 12 months (Cr)",
          sort_order: 1,
          isNumeric: true
        },
        {
          title: "market_average_shares_outstanding",
          name: "Market Average Shares Outstanding",
          sort_order: 2,
          isNumeric: true
        },
        {
          title: "average_marketCapitalization",
          name: "Average Market Cap",
          sort_order: 3,
          isNumeric: true
        },
        {
          title: "market_eps_global",
          name: "Market Earnings",
          sort_order: 4,
          isNumeric: true
        },
        {
          title: "market_avg_cash_from_operating_activities",
          name:
            "Market average cash flow per share Or Market Avg cash from operating activities",
          sort_order: 5,
          isNumeric: true
        },
        {
          title: "market_dividend_global",
          name: "Market Dividend",
          sort_order: 6,
          isNumeric: true
        },
        {
          title: "cut_off_book_market_ratio",
          name: "Book-market ratio (cut-off of top 20% of the market)",
          sort_order: 7,
          isNumeric: true
        },
        {
          title: "cut_off_pe_ratio",
          name: "Cut-off PE ratio (in bottom 20% of the market)",
          sort_order: 8,
          isNumeric: true
        },
        {
          title: "cut_off_pcf_ratio",
          name: "Cut-off P/CF ratio (in bottom 20% of the market)",
          sort_order: 9,
          isNumeric: true
        },
        {
          title: "cut_off_pb_ratio",
          name: "Cut-off P/B ratio (in bottom 20% of the market)",
          sort_order: 10,
          isNumeric: true
        },
        {
          title: "cut_off_pdividend_ratio",
          name: "Cut-off P/Dividend ratio (in bottom 20% of the market)",
          sort_order: 10,
          isNumeric: true
        }
      ],
      rawDataApi: "getMarketInfo",
      rawData: [],
      rawDataGtZero: [],
      rawDataGt500: [],
      ddate: "" //new Date().setDate(new Date().getDate() - 1)
    };
  },
  methods: {
    getRawData() {
      this.rawData = [];
      this.rawDataGtZero = [];
      this.rawDataGt500 = [];
      let myself = this;
      http.post(
        this.rawDataApi,
        { my_date: myself.ddate != "" ? myself.getDate(myself.ddate) : "" },
        (error, response) => {
          // myself.rawData = response[0];
          // if(response.length>0){
          myself.rawData = response;
          if (myself.rawData.common_data) {
            myself.ddate = new Date(myself.rawData.common_data.date);
            console.log("Date", myself.rawData.common_data.date);
          } else {
            myself.ddate = new Date().setDate(new Date().getDate() - 1);
          }
          // .common_data;
          // myself.rawDataGtZero = response.common_data_GreaterThanZero;
          // myself.rawDataGt500 = response.common_data_GreaterThanFiveHundred;
          // }
        }
      );
    },
    getSelDate(e) {
      console.log("Selected date", e);
      this.ddate = e;
      this.getRawData();
    },
    getGtZero() {
      this.rawDataGtZero = [];
      let myself = this;
      http.get(
        "calculateAllCompaniesFieldsGtZeroMcp",
        {},
        (error, response) => {
          myself.rawDataGtZero = response;
        }
      );
    },
    getGt500() {
      this.rawDataGt500 = [];
      let myself = this;
      http.get(
        "calculateAllCompaniesFieldsGtFiveHundredMcp",
        {},
        (error, response) => {
          myself.rawDataGt500 = response;
        }
      );
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table th.column-sort {
  cursor: pointer;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/market-data/marketInfo.vue